import React from 'react'
import './ClassesPage.css'
import Header from '../components/Header'

function ClassesPage() {
  return (
    <div className="page_container" id="classes-page">
      <section className="page_section" id="hero-section">
        <Header />
        <div className="sub_section title_section">
          <h1>Uurrooster</h1>
        </div>
        <div className="sub_section schedule_section">
          <h2 className="schedule_title">HERFSTREEKS</h2>
          <p className="schedule_period">van 21/09 tot en met 20/12 (13 lesweken)</p>
          
          <div className="schedule_grid">
            <div className="schedule_day">
              <h3>maandag</h3>
              <div className="class_slot">
                <p className="time">17:30–18:30</p>
                <p className="class_name">Pole Technique 1</p>
              </div>
              <div className="class_slot">
                <p className="time">18:35–20:05</p>
                <p className="class_name">Pole Technique 3</p>
              </div>
              <div className="class_slot">
                <p className="time">20:15–21:45</p>
                <p className="class_name">Pole Technique 2/3</p>
              </div>
            </div>

            <div className="schedule_day">
              <h3>dinsdag</h3>
              <div className="class_slot">
                <p className="time">17:30–19:00</p>
                <p className="class_name">Pole Intro</p>
              </div>
              <div className="class_slot">
                <p className="time">19:10–20:10</p>
                <p className="class_name">Pole Heels 1</p>
              </div>
              <div className="class_slot">
                <p className="time">20:15–21:45</p>
                <p className="class_name">Pole Technique 2</p>
              </div>
            </div>

            <div className="schedule_day">
              <h3>woensdag</h3>
              <div className="class_slot">
                <p className="time">18:00–19:30</p>
                <p className="class_name">Pole Technique 2</p>
              </div>
              <div className="class_slot">
                <p className="time">19:40–21:10</p>
                <p className="class_name">Pole Technique 3/4</p>
              </div>
            </div>

            <div className="schedule_day">
              <h3>donderdag</h3>
              <div className="class_slot">
                <p className="time">18:30–20:00</p>
                <p className="class_name">Pole Technique 1</p>
              </div>
              <div className="class_slot">
                <p className="time">20:10–21:40</p>
                <p className="class_name">Pole Technique 3</p>
              </div>
            </div>
            
            <div className="schedule_day">
              <h3>vrijdag</h3>
              <div className="class_slot">
                <p className="time">18:00–19:00</p>
                <p className="class_name">Pole Flow 1</p>
              </div>
              <div className="class_slot">
                <p className="time">19:10–20:10</p>
                <p className="class_name">Pole Intro</p>
              </div>
            </div>
            
            <div className="schedule_day">
              <h3>zaterdag</h3>
              <div className="class_slot">
                <p className="time">10:00–11:30</p>
                <p className="class_name">Flex (Frontsplits) &amp; Bootcamp</p>
              </div>
              <div className="class_slot">
                <p className="time">11:45–13:15</p>
                <p className="class_name">Pole Technique 3/4</p>
              </div>
              <div className="class_slot">
                <p className="time">14:45–16:15</p>
                <p className="class_name">Pole Intro</p>
              </div>
            </div>
            <div className="schedule_day">
              <h3>zondag</h3>
              <div className="class_slot">
                <p className="time">09:30–11:00</p>
                <p className="class_name">Pole Intro</p>
              </div>
              <div className="class_slot">
                <p className="time">11:10–12:40</p>
                <p className="class_name">Pole Technique 1/2</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ClassesPage
